import { Link, useParams } from 'react-router-dom';
import { Breadcrumb, Layout, Spin, theme } from 'antd';

import { PageLayout } from '@app/web-components';

import { NotFoundPage } from '../../../../../common';
import { useEdaVendor } from '../data';
import { EditForm } from '../forms';

import { TITLE } from './landing';

export const EditPage = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const { id } = useParams();
  const { data, error, isPending } = useEdaVendor(Number(id) || 0);

  if (error || (!isPending && !data)) {
    return <NotFoundPage />;
  }

  return (
    <>
      <Breadcrumb
        style={{ margin: '16px 0' }}
        items={[
          { title: <Link to="/">Home</Link> },
          { title: 'Admin' },
          { title: 'Maps' },
          { title: <Link to="../">{TITLE}</Link> },
          { title: 'Edit' },
        ]}
      />
      <Layout.Content
        style={{
          padding: 24,
          margin: 'auto',
          height: '100%',
          width: '100%',
          maxWidth: 1200,
          minHeight: 0,
          background: colorBgContainer,
          overflow: 'auto',
        }}
      >
        <PageLayout.Title title="Edit Vendor Process Mapping" />
        {isPending ? (
          <Spin tip="Loading Vendor Process Mapping" style={{ width: '100%' }}>
            <span></span>
          </Spin>
        ) : (
          <EditForm record={data} />
        )}
      </Layout.Content>
    </>
  );
};
